export const getRoleBadgeColor = (role) => {
  const roleLower = (role || "").toLowerCase();
  if (roleLower.includes("admin")) {
    return { bg: "#FFF4ED", color: "#EA580C", border: "#FED7AA" };
  }
  return { bg: "#EFF6FF", color: "#1E40AF", border: "#BFDBFE" };
};

